import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
/**
 *  Generates a list of error message elements for use with form groups
 *
 */
function ErrorMessages(_ref) {
  let {
    id,
    className,
    errors = [],
    showErrors,
    showIcon = true,
    ...rest
  } = _ref;
  const rootClassName = clsx(className, 'has-error');
  const renderErrors = typeof showErrors === 'undefined' ? !!errors.length : showErrors;
  return renderErrors && /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "errorMessages",
    className: rootClassName
  }, rest), [].concat(errors).map((errorMessage, key) => /*#__PURE__*/_jsx("span", {
    className: "help-block validation-message error-message",
    id: id,
    role: "alert",
    "aria-live": "polite"
  }, `error-${key}`, showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "danger"
  }))), ' ', errorMessage)));
}
export default ErrorMessages;